/* eslint-disable */

import React, { useEffect, useRef, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import client from '../../../api/client';
import { useLoadConfig } from '../../../hooks/useLoadConfig';

import { DatePicker, Image } from 'antd';
import th from 'antd/es/date-picker/locale/th_TH';
import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import moment from 'moment';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import { Link, useLocation } from 'react-router-dom';
import placeholderImg from '../../../assets/images/placeholder.webp';
import ShopExpireAlertBanners from '../../../components/shop/ShopExpireAlertBanners';
import ShopExpireFilterChips from '../../../components/shop/ShopExpireFilterChips';
import ShopSellLicensesPanel from '../../../components/shop/ShopSellLicensesPanel';
import BtnGogo from '../../../components/buttongoto/ButtonGoto';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import Tabs from '../../../components/tabs/Tabs';
import BarcodeScanner from '../../../components/scanner/BarcodeScanner';
import { colors } from '../../../helper/constant/colors';

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

function MyShop_Seller_MyProduct(props) {
  const queryClient = useQueryClient();
  const shopId = props.permitdata?.shop_id;
  const config = useLoadConfig(props.permitdata);
  const shopitemlist = config.shopItems;
  const shopitemTotal = config.shopItemTotal;

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tabParam = query.get('tab');
  const [forcepage, setForcepage] = useState(0);
  const [activeTab, setActiveTab] = useState('ราคาปกติ');
  const [currentPage, setCurrentPage] = useState(1);
  const [shopitemlist_searchfind, setShopitemlist_searchfind] = useState('');
  const searchDebounceRef = useRef(null);
  const [loadItemRequest, setLoadItemRequest] = useState(null);
  const [expireFilter, setExpireFilter] = useState('all');

  const TAB_SERVER_PARAM = {
    'ราคาปกติ': '',
    'ลดราคา': 'pro',
    'สินค้าหมด': 'blank',
    'หมดอายุ': 'expired',
    'สินค้านอกสิทธิทะเบียนยา': 'unlicensed',
  };

  const TAB_COUNT_KEY = {
    'ราคาปกติ': 'all',
    'ลดราคา': 'pro',
    'สินค้าหมด': 'blank',
    'หมดอายุ': 'expired',
    'สินค้านอกสิทธิทะเบียนยา': 'unlicensed',
  };

  const formatTabLabel = (id) => {
    const key = TAB_COUNT_KEY[id];
    const n = key ? (config.tabCounts?.[key] ?? 0) : 0;
    return `${id} (${n})`;
  };
  const parseTabLabel = (label) => String(label).replace(/ \(\d+\)$/, '');

  const initialTabId =
    tabParam && Object.prototype.hasOwnProperty.call(TAB_SERVER_PARAM, tabParam)
      ? tabParam
      : 'ราคาปกติ';
  const [tabsDefaultActive, setTabsDefaultActive] = useState(`${initialTabId} (0)`);

  const showExpireFilterChips = activeTab === 'ราคาปกติ' || activeTab === 'ลดราคา';

  const switchToTab = (tabId, nextExpireFilter) => {
    const nextFilter =
      nextExpireFilter !== undefined
        ? nextExpireFilter
        : tabId === 'ราคาปกติ' || tabId === 'ลดราคา'
          ? expireFilter
          : 'all';
    setActiveTab(tabId);
    setTabsDefaultActive(formatTabLabel(tabId));
    setCurrentPage(1);
    setForcepage(0);
    setShopitemlist_searchfind('');
    setExpireFilter(nextFilter);
    loadItems(1, TAB_SERVER_PARAM[tabId] ?? 'onsell', '', nextFilter);
  };

  const [shopitemedit, setShopitemedit] = useState({});
  const [tableitem, setTableitem] = useState([]);
  const [tablestock, setTablestock] = useState([]);
  const [trigerstock, setTrigerstock] = useState(false);
  const [sortdata, setSortdata] = useState(false);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_editprice, setModal_editprice] = useState(false);

  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  const buddhistLocale = {
    ...th,
    lang: {
      ...th.lang,
      fieldDateFormat: 'BBBB-MMM-DD',
      fieldDateTimeFormat: 'BBBB-MMM-DD HH:mm:ss',
      yearFormat: 'BBBB',
      cellYearFormat: 'BBBB',
    },
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const shopItemDetailQuery = useQuery({
    queryKey: [
      'shopitem-detail',
      loadItemRequest?.item?.shopitem_id,
      loadItemRequest?.item?.shop_id,
      loadItemRequest?.item?.productitem_id,
      loadItemRequest?.nonce,
    ],
    queryFn: async () => {
      await sleep(200);
      const item = loadItemRequest.item;
      const formData = new FormData();
      formData.append('shopitem_id', item.shopitem_id);
      formData.append('shop_id', item.shop_id);
      formData.append('productitem_id', item.productitem_id);

      const response = await client.post('/api/product/shopitem/getproductbyid', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.status !== 'OK') {
        const err = new Error(response.data.message || 'getproductbyid failed');
        err.isWarning = true;
        throw err;
      }
      return response.data.item;
    },
    enabled: !!loadItemRequest,
  });

  const editShopItemMutation = useMutation({
    mutationFn: async (formData) => {
      await sleep(200);
      const response = await client.post('/api/product/shopitem/edit', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      return response.data;
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      if (data.status !== 'OK') {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
        return;
      }

      queryClient.invalidateQueries({ queryKey: ['load-config', shopId] });
      queryClient.invalidateQueries({ queryKey: ['expire-alert-counts', shopId] });
      props.callback_datachanged('shopitem-edit', data.items);
      setModal_editprice(false);
      setModal_popup({
        modaltype: 'modal-success',
        headers: 'สำเร็จ',
        message: data.message,
        enable: true,
      });
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const deleteShopItemMutation = useMutation({
    mutationFn: async (item) => {
      await sleep(200);
      const formData = new FormData();
      formData.append('shopitem_id', item.shopitem_id);
      formData.append('shop_id', item.shop_id);
      formData.append('productitem_id', item.productitem_id);

      const response = await client.post('/api/product/shopitem/delete', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      setShopitemedit({});
      if (data.status !== 'OK') {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
        return;
      }

      queryClient.invalidateQueries({ queryKey: ['load-config', shopId] });
      queryClient.invalidateQueries({ queryKey: ['expire-alert-counts', shopId] });
      props.callback_datachanged('shopitem-delete', data.id);
      setCurrentPage(1);
      setForcepage(0);
      config.load(1, TAB_SERVER_PARAM[activeTab] ?? 'onsell', shopitemlist_searchfind, true, expireFilter);
      setModal_popup({
        modaltype: 'modal-success',
        headers: 'สำเร็จ',
        message: data.message,
        enable: true,
      });
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setShopitemedit({});
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  function loadItems(page, tab, search, nextExpireFilter) {
    const filter =
      nextExpireFilter !== undefined
        ? nextExpireFilter
        : tab === 'pro' || tab === '' || tab === 'all' || tab === 'onsell'
          ? expireFilter
          : 'all';
    config.load(page, tab, search, true, filter);
  }

  function handleExpireFilterChange(nextFilter) {
    setExpireFilter(nextFilter);
    setCurrentPage(1);
    setForcepage(0);
    loadItems(1, TAB_SERVER_PARAM[activeTab] ?? 'onsell', shopitemlist_searchfind, nextFilter);
  }

  function handleSearchChange(value) {
    setShopitemlist_searchfind(value);
    clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      setForcepage(0);
      setCurrentPage(1);
      loadItems(1, TAB_SERVER_PARAM[activeTab] ?? 'onsell', value);
    }, 400);
  }

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {
    api_delete_shopitem(shopitemedit);
  }

  const cfilter = (shopitem) => {
    var pricedata = [];
    var rows = shopitem.pricetable.split('##');
    if (rows.length > 0) {
      rows.forEach((rowitem, index) => {
        var items = rowitem.split('**');
        if (items.length >= 4) {
          pricedata.push({
            pricelist_id: shopitem.shopitem_id + '-' + index.toString(),
            unit: items[0],
            price: items[1],
            pricepromotion: items[2],
            expire: items[3],
          });
        }
      });
    }
    return pricedata;
  };

  /** Near-expiry: expire date on or before today+30 days (includes already expired). */
  const isNearExpire = (expire) => {
    if (!expire) return false;
    const exp = dayjs(expire).startOf('day');
    if (!exp.isValid()) return false;
    return !exp.isAfter(dayjs().startOf('day').add(30, 'day'));
  };

  const renderExpireCell = (expire) => {
    const text = dayjs(new Date(expire)).format('DD MMM BBBB');
    if (!isNearExpire(expire)) {
      return text;
    }
    return (
      <span className='expire-near-warn'>
        {text} <i className='fas fa-exclamation-triangle' aria-hidden='true' />
      </span>
    );
  };

  function selectstock(expire, val) {
    const nexttableitem = tablestock.map((item) => {
      if (item.expire !== expire) {
        return item;
      } else {
        return {
          ...item,
          stock: val,
        };
      }
    });
    setTablestock(nexttableitem);
    setSortdata(false);
  }

  function selectnumber(id, val, keys) {
    const nexttableitem = tableitem.map((item) => {
      if (item.pricelist_id !== id) {
        return item;
      } else {
        if (Number(val) > -1) {
          return {
            ...item,
            [keys]: val,
          };
        } else {
          return {
            ...item,
            [keys]: 0,
          };
        }
      }
    });
    setTableitem(nexttableitem);
    setSortdata(false);
  }

  function selectepiredate(id, date, datestr) {
    if (date !== null) {
      const nexttableitem = tableitem.map((item) => {
        if (item.pricelist_id !== id) {
          return item;
        } else {
          return {
            ...item,
            expire: date.format('YYYY-MM-DD'),
          };
        }
      });
      setTableitem(nexttableitem);
    }
    setSortdata(false);
  }

  function addpricelist() {
    if (tableitem.length < 10) {
      var id = moment(new Date()).format('YYYYMMDDHHmmssSSS');
      var exp = moment(new Date()).format('YYYY-MM-DD');
      setTableitem((oldArray) => [
        ...oldArray,
        { pricelist_id: id, unit: '', price: '', pricepromotion: '', expire: exp },
      ]);
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'ท่านสามารถใส่ราคาย่อยได้สูงสุด 10 รายการ',
        enable: true,
      });
    }
    setSortdata(false);
  }

  function removepricelist(id) {
    if (tableitem.length > 1) {
      setTableitem(
        tableitem.filter(function (item) {
          return item.pricelist_id !== id;
        }),
      );
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'ตารางราคาต้องมีอย่างน้อย 1 รายการ',
        enable: true,
      });
    }
    setSortdata(false);
  }

  useEffect(() => {
    const initialTab = tabParam && Object.prototype.hasOwnProperty.call(TAB_SERVER_PARAM, tabParam) ? tabParam : '';
    const serverTab = initialTab ? TAB_SERVER_PARAM[initialTab] : '';
    loadItems(1, serverTab, '');
    if (initialTab) {
      setActiveTab(initialTab);
      setTabsDefaultActive(formatTabLabel(initialTab));
    }
  }, []);

  useEffect(() => {
    setTabsDefaultActive(formatTabLabel(activeTab));
  }, [config.tabCounts, activeTab]);

  useEffect(() => {
    if (!loadItemRequest) return;

    if (shopItemDetailQuery.isFetching) {
      setmodal_load({ enable: true, message: 'กำลังโหลดข้อมูลสินค้า' });
      return;
    }

    if (shopItemDetailQuery.isSuccess && shopItemDetailQuery.data) {
      setmodal_load({ enable: false, message: '' });
      const item = loadItemRequest.item;
      const tmp = {
        ...item,
        isblank: shopItemDetailQuery.data.isblank,
        ispro: shopItemDetailQuery.data.ispro,
        on_stock: shopItemDetailQuery.data.on_stock,
        on_sold: shopItemDetailQuery.data.on_sold,
      };
      setShopitemedit(tmp);
      props.callback_datachanged('shopitem-update-stock', shopItemDetailQuery.data);
      openedit_modal();
      setLoadItemRequest(null);
      return;
    }

    if (shopItemDetailQuery.isError) {
      setmodal_load({ enable: false, message: '' });
      setShopitemedit({});
      const err = shopItemDetailQuery.error;
      setModal_popup({
        modaltype: err?.isWarning ? 'modal-warning' : 'modal-error',
        headers: err?.isWarning ? 'ขออภัย' : 'ผิดพลาด',
        message: err?.message || 'โหลดข้อมูลสินค้าไม่สำเร็จ',
        enable: true,
      });
      setLoadItemRequest(null);
    }
  }, [
    loadItemRequest,
    shopItemDetailQuery.isFetching,
    shopItemDetailQuery.isSuccess,
    shopItemDetailQuery.isError,
    shopItemDetailQuery.data,
    shopItemDetailQuery.error,
  ]);

  useEffect(() => {
    if (shopitemedit.pricetable !== undefined) {
      var stockdata = [];
      var pricedata = [];
      var rows = shopitemedit.pricetable.split('##');
      var stock = shopitemedit.on_stock.split('##');
      stock.forEach((rowitem, index) => {
        var stockitems = rowitem.split('**');
        stockdata.push({
          expire: stockitems[0],
          stock: Number(stockitems[1]),
        });
      });
      setTablestock(stockdata);

      if (rows.length > 0) {
        rows.forEach((rowitem, index) => {
          var items = rowitem.split('**');
          if (items.length >= 4) {
            var id = moment(new Date()).format('YYYYMMDDHHmmssSSS') + '-' + index.toString();
            pricedata.push({
              pricelist_id: id,
              unit: items[0],
              price: items[1],
              pricepromotion: items[2],
              expire: items[3],
            });
          }
        });
      }
      setTableitem(pricedata);
    }
  }, [shopitemedit]);

  useEffect(() => {
    for (const item of tableitem) {
      var fnd = tablestock.find((element) => {
        return element.expire === item.expire;
      });
      if (fnd === undefined) {
        setTablestock((oldArray) => [...oldArray, { expire: item.expire, stock: 0 }]);
      }
    }
    setTrigerstock(!trigerstock);
  }, [tableitem]);

  useEffect(() => {
    for (const item of tablestock) {
      var fnd = tableitem.find((element) => {
        return element.expire === item.expire;
      });
      if (fnd === undefined) {
        setTablestock(
          tablestock.filter(function (itemx) {
            return itemx.expire !== item.expire;
          }),
        );
      }
    }
  }, [trigerstock]);

  function cancel_edit() {
    setModal_editprice(false);
    setTableitem([]);
    setShopitemedit({});
  }

  function openedit_modal() {
    setModal_editprice(true);
  }

  function sortitem() {
    setTableitem(
      tableitem.sort(
        (firstItem, secondItem) =>
          Date.parse(new Date(firstItem.expire)) - Date.parse(new Date(secondItem.expire)) ||
          Number(firstItem.unit) - Number(secondItem.unit),
      ),
    );
    setTablestock(
      tablestock.sort(
        (firstItem, secondItem) =>
          Date.parse(new Date(firstItem.expire)) - Date.parse(new Date(secondItem.expire)),
      ),
    );
    setSortdata(true);
  }


  function api_load_shopitem_stock(item) {
    setLoadItemRequest({ item, nonce: Date.now() });
  }

  async function api_edit_shopitem() {
    var formstockelement = document.getElementById('form-stock');
    var formpriceelement = document.getElementById('form-price');

    if (formpriceelement.checkValidity() === false || formstockelement.checkValidity() === false) {
      formstockelement.classList.add('was-validated');
      formpriceelement.classList.add('was-validated');

      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        enable: true,
      });
    } else {
      formstockelement.classList.remove('was-validated');
      formpriceelement.classList.remove('was-validated');

      if (tableitem.length > 0) {
        if (sortdata === true || tableitem.length === 1) {
          var temp = [];
          var proprice_found = false;
          var proprice_error = false;
          var stocksum = 0;
          var on_stock = [];
          var on_sold = '';

          var firstprice_unit = '';
          var firstprice_price = '';
          var firstprice_new = '';
          var firstprice_expire = '';
          var firstprice_stock = '';

          const formData = new FormData();
          tablestock.forEach((item, index) => {
            var x = item.expire + '**' + item.stock;
            on_stock.push(x);
            stocksum += Number(item.stock);
          });
          var duplcateref = [];
          var duplcatebit = false;
          tableitem.forEach((item, index) => {
            var dp = item.unit + '**' + item.expire;
            var fnd_dp = duplcateref.find((element) => {
              return element === dp;
            });
            if (fnd_dp !== undefined) {
              duplcatebit = true;
            }
            duplcateref.push(dp);

            var x = item.unit + '**' + item.price + '**' + (item.pricepromotion || '0') + '**' + item.expire;
            temp.push(x);
            on_sold = '0';
            if (firstprice_unit === '') {
              firstprice_unit = item.unit;
              firstprice_price = item.price;
              firstprice_new = item.pricepromotion || '0';
              firstprice_expire = item.expire;
              var fnd = tablestock.find((element) => {
                return element.expire === item.expire;
              });
              if (fnd !== undefined) {
                firstprice_stock = fnd.stock;
              }
            }

            if (
              proprice_found === false &&
              Number(item.pricepromotion) > 0 &&
              Number(item.pricepromotion) < Number(item.price)
            ) {
              proprice_found = true;
              formData.append('first_priceunit', item.unit);
              formData.append('first_pricebase', item.price);
              formData.append('first_pricenew', item.pricepromotion || '0');
              formData.append('first_expire', item.expire);
              const fnd = tablestock.find((element) => {
                return element.expire === item.expire;
              });
              if (fnd !== undefined) {
                formData.append('first_stock', fnd.stock);
              }
            }

            if (
              Number(item.pricepromotion) > 0 &&
              Number(item.pricepromotion) >= Number(item.price)
            ) {
              proprice_error = true;
            }
          });

          if (proprice_error === true) {
            setModal_popup({
              modaltype: 'modal-warning',
              headers: 'ขออภัย',
              message: 'ราคาโปรโมชั่นจะต้องน้อยกว่าราคาขายปกติ',
              enable: true,
            });
          } else {
            if (duplcatebit === false) {
              var pricestring = temp.join('##');
              formData.append('shopitem_id', shopitemedit.shopitem_id);
              formData.append('shop_id', props.permitdata.shop_id);
              formData.append('shop_name', props.permitdata.shop_name);
              formData.append('shop_province', props.permitdata.shop_province);
              formData.append('productitem_id', shopitemedit.productitem_id);
              formData.append('productitem_name', shopitemedit.productitem_name);
              formData.append('productitem_inter', shopitemedit.productitem_inter);
              formData.append('img1_key', shopitemedit.img1_key);

              if (proprice_found === false) {
                formData.append('first_priceunit', firstprice_unit);
                formData.append('first_pricebase', firstprice_price);
                formData.append('first_pricenew', firstprice_new || '0');
                formData.append('first_expire', firstprice_expire);
                formData.append('first_stock', firstprice_stock);
                formData.append('ispro', 'False');
              } else {
                formData.append('ispro', 'True');
              }
              formData.append('ads', shopitemedit.ads);
              formData.append('status', 'OnSell');
              if (stocksum > 0) {
                formData.append('isblank', 'False');
              } else {
                formData.append('isblank', 'True');
              }

              formData.append('pricetable', pricestring);
              formData.append('on_sold', on_sold);
              formData.append('on_stock', on_stock.join('##'));
              formData.append('username', props.permitdata.shop_username);

              setmodal_load({ enable: true, message: 'กำลังแก้ไขข้อมูลสินค้า' });
              editShopItemMutation.mutate(formData);
            } else {
              setModal_popup({
                modaltype: 'modal-warning',
                headers: 'ขออภัย',
                message: 'ตรวจพบจำนวนชิ้นต่อชุดซ้ำกัน (แยกตามวันหมดอายุ)',
                enable: true,
              });
            }
          }
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: 'กรุณากดปุ่ม "เรียงตารางราคาใหม่"',
            enable: true,
          });
        }
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: 'ไม่พบตารางราคา',
          enable: true,
        });
      }
    }
  }

  function api_delete_shopitem(item) {
    setmodal_load({ enable: true, message: 'กำลังลบสินค้าออกจากร้าน' });
    deleteShopItemMutation.mutate(item);
  }

  const pageSize = 20;
  const pageCount = Math.ceil((shopitemTotal ?? 0) / pageSize);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setCurrentPage(newPage);
    setForcepage(event.selected);
    loadItems(newPage, TAB_SERVER_PARAM[activeTab] ?? 'onsell', shopitemlist_searchfind);
  };

  return (
    <div className='my-0 font-inter font-th'>
      {/* Modern Search & Action Bar */}
      <div className='search-container-modern'>
        <div className='search-input-group'>
          <i className='fas fa-search'></i>
          <input
            type='text'
            className='modern-search-input'
            placeholder='ค้นหา : ชื่อสินค้าภาษาไทย/อังกฤษ หรือ บาร์โค้ด'
            value={shopitemlist_searchfind}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </div>
        <button
          type='button'
          className='btn btn-outline-secondary'
          onClick={() => setIsScannerOpen(true)}
          style={{ borderRadius: '10px', height: '42px' }}
        >
          <i className='fas fa-barcode mr-1'></i> สแกน
        </button>
        <Link to='/myshop/seller/newproduct' className='btn-add-product-modern'>
          <i className='fas fa-plus'></i> เพิ่มสินค้าใหม่
        </Link>
      </div>

      <ShopSellLicensesPanel licenses={config.sellLicenses} />

      <ShopExpireAlertBanners
        nearCount={config.nearExpireCount ?? 0}
        nearCountAll={config.nearExpireCountAll ?? 0}
        nearCountPro={config.nearExpireCountPro ?? 0}
        expiredCount={config.tabCounts?.expired ?? 0}
        onViewNearAll={() => switchToTab('ราคาปกติ', 'near')}
        onViewNearPro={() => switchToTab('ลดราคา', 'near')}
        onViewExpired={() => switchToTab('หมดอายุ', 'all')}
      />

      <div className='row'>
        <div className='col-12'>
          <Tabs
            defaultActive={tabsDefaultActive}
            callback_tabclick={(label) => {
              const tabId = parseTabLabel(label);
              setActiveTab(tabId);
              setTabsDefaultActive(formatTabLabel(tabId));
              setCurrentPage(1);
              setForcepage(0);
              setShopitemlist_searchfind('');
              if (tabId !== 'ราคาปกติ' && tabId !== 'ลดราคา') {
                setExpireFilter('all');
              }
              loadItems(
                1,
                TAB_SERVER_PARAM[tabId] ?? 'onsell',
                '',
                tabId === 'ราคาปกติ' || tabId === 'ลดราคา' ? expireFilter : 'all',
              );
            }}
            border_r={true}
          >
            {/* --- Normal Price Tab --- */}
            <div label={formatTabLabel('ราคาปกติ')}>
              {showExpireFilterChips ? (
                <ShopExpireFilterChips value={expireFilter} onChange={handleExpireFilterChange} />
              ) : null}
              <div className='product-card-list'>
                {shopitemlist.length > 0 ? (
                  shopitemlist.map((shopitem) => (
                    <div className='modern-product-card' key={shopitem.shopitem_id}>
                      <div className='product-image-container'>
                        <Image
                          src={
                            shopitem?.productitem_id && shopitem?.img1_key
                              ? `${process.env.REACT_APP_IMAGE_URL}${shopitem.productitem_id}/${shopitem.productitem_id}-1-${shopitem.img1_key}.jpg`
                              : placeholderImg
                          }
                          fallback={placeholderImg}
                        />
                      </div>
                      <div className='product-info-container'>
                        <div className='product-id-badge'>
                          #{shopitem.productitem_id}
                          {shopitem.ads === true && (
                            <span className='badge badge-pill badge-success'>Ads</span>
                          )}
                        </div>
                        <div className='product-name-th'>{shopitem.productitem_name}</div>
                        <div className='product-name-en'>{shopitem.productitem_inter}</div>
                        <table className='card-price-table'>
                          <thead>
                            <tr>
                              <th>จำนวนชิ้น</th>
                              <th>ราคา</th>
                              <th>วันหมดอายุ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cfilter(shopitem).map((pricelist) => (
                              <tr key={pricelist.pricelist_id}>
                                <td>{pricelist.unit} ชิ้น</td>
                                <td>{pricelist.price} บาท</td>
                                <td>{renderExpireCell(pricelist.expire)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className='action-container'>
                        <button className='btn-card-action btn-card-edit' onClick={() => api_load_shopitem_stock(shopitem)}>
                          <i className='mdi mdi-file-edit-outline'></i> แก้ไข
                        </button>
                        <button
                          className='btn-card-action btn-card-delete'
                          onClick={() => {
                            setShopitemedit(shopitem);
                            setModal_popup({ modaltype: 'modal-confirm', headers: 'กรุณายืนยัน', message: 'ท่านต้องการลบรายการสินค้านี้ใช่หรือไม่?', enable: true });
                          }}
                        >
                          <i className='mdi mdi-eraser'></i> ลบ
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-center py-5 text-muted'>ไม่พบรายการสินค้า</div>
                )}
              </div>
              <div className='meya-pagination-container mt-4'>
                <ReactPaginate breakLabel='...' nextLabel='>' onPageChange={handlePageClick} pageRangeDisplayed={5} pageCount={pageCount} previousLabel='<' renderOnZeroPageCount={null} forcePage={forcepage} />
              </div>
            </div>

            {/* --- Discount Tab --- */}
            <div label={formatTabLabel('ลดราคา')}>
              {showExpireFilterChips ? (
                <ShopExpireFilterChips value={expireFilter} onChange={handleExpireFilterChange} />
              ) : null}
              <div className='product-card-list'>
                {shopitemlist.length > 0 ? (
                  shopitemlist.map((shopitem) => (
                    <div className='modern-product-card' key={shopitem.shopitem_id}>
                      <div className='product-image-container'>
                        <Image
                          src={
                            shopitem?.productitem_id && shopitem?.img1_key
                              ? `${process.env.REACT_APP_IMAGE_URL}${shopitem.productitem_id}/${shopitem.productitem_id}-1-${shopitem.img1_key}.jpg`
                              : placeholderImg
                          }
                          fallback={placeholderImg}
                        />
                      </div>
                      <div className='product-info-container'>
                        <div className='product-id-badge'>
                          #{shopitem.productitem_id}
                          <span className='badge badge-pill badge-warning ml-2'>โปรโมชั่น</span>
                        </div>
                        <div className='product-name-th'>{shopitem.productitem_name}</div>
                        <div className='product-name-en'>{shopitem.productitem_inter}</div>
                        <table className='card-price-table'>
                          <thead>
                            <tr>
                              <th>จำนวนชิ้น</th>
                              <th>ราคา ปกติ/โปร</th>
                              <th>วันหมดอายุ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cfilter(shopitem).map((pricelist) => (
                              <tr key={pricelist.pricelist_id}>
                                <td>{pricelist.unit} ชิ้น</td>
                                <td>
                                  <span style={{ textDecoration: 'line-through', fontSize: '11px', color: '#999' }}>{pricelist.price}</span>
                                  <span className='text-danger font-weight-bold ml-2'>{pricelist.pricepromotion}</span> บาท
                                </td>
                                <td>{renderExpireCell(pricelist.expire)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className='action-container'>
                        <button className='btn-card-action btn-card-edit' onClick={() => api_load_shopitem_stock(shopitem)}>
                          <i className='mdi mdi-file-edit-outline'></i> แก้ไข
                        </button>
                        <button
                          className='btn-card-action btn-card-delete'
                          onClick={() => {
                            setShopitemedit(shopitem);
                            setModal_popup({ modaltype: 'modal-confirm', headers: 'กรุณายืนยัน', message: 'ท่านต้องการลบรายการสินค้านี้ใช่หรือไม่?', enable: true });
                          }}
                        >
                          <i className='mdi mdi-eraser'></i> ลบ
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-center py-5 text-muted'>ไม่พบรายการสินค้าลดราคา</div>
                )}
              </div>
              <div className='meya-pagination-container mt-4'>
                <ReactPaginate breakLabel='...' nextLabel='>' onPageChange={handlePageClick} pageRangeDisplayed={5} pageCount={pageCount} previousLabel='<' renderOnZeroPageCount={null} forcePage={forcepage} />
              </div>
            </div>

            {/* --- Out of Stock Tab --- */}
            <div label={formatTabLabel('สินค้าหมด')}>
              <div className='product-card-list'>
                {shopitemlist.length > 0 ? (
                  shopitemlist.map((shopitem) => (
                    <div className='modern-product-card' key={shopitem.shopitem_id} style={{ opacity: 0.8 }}>
                      <div className='product-image-container' style={{ filter: 'grayscale(100%)' }}>
                        <Image
                          src={
                            shopitem?.productitem_id && shopitem?.img1_key
                              ? `${process.env.REACT_APP_IMAGE_URL}${shopitem.productitem_id}/${shopitem.productitem_id}-1-${shopitem.img1_key}.jpg`
                              : placeholderImg
                          }
                          fallback={placeholderImg}
                        />
                      </div>
                      <div className='product-info-container'>
                        <div className='product-id-badge'>
                          #{shopitem.productitem_id}
                          <span className='badge badge-pill badge-secondary ml-2'>สินค้าหมด</span>
                        </div>
                        <div className='product-name-th'>{shopitem.productitem_name}</div>
                        <div className='product-name-en'>{shopitem.productitem_inter}</div>
                        <table className='card-price-table'>
                          <thead>
                            <tr>
                              <th>จำนวนชิ้น</th>
                              <th>ราคา</th>
                              <th>วันหมดอายุ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cfilter(shopitem).map((pricelist) => (
                              <tr key={pricelist.pricelist_id}>
                                <td>{pricelist.unit} ชิ้น</td>
                                <td>{pricelist.price} บาท</td>
                                <td>{renderExpireCell(pricelist.expire)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className='action-container'>
                        <button className='btn-card-action btn-card-edit' onClick={() => api_load_shopitem_stock(shopitem)}>
                          <i className='mdi mdi-file-edit-outline'></i> เติมสต็อก
                        </button>
                        <button
                          className='btn-card-action btn-card-delete'
                          onClick={() => {
                            setShopitemedit(shopitem);
                            setModal_popup({ modaltype: 'modal-confirm', headers: 'กรุณายืนยัน', message: 'ท่านต้องการลบรายการสินค้านี้ใช่หรือไม่?', enable: true });
                          }}
                        >
                          <i className='mdi mdi-eraser'></i> ลบ
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-center py-5 text-muted'>ไม่มีสินค้าที่หมดสต็อก</div>
                )}
              </div>
              <div className='meya-pagination-container mt-4'>
                <ReactPaginate breakLabel='...' nextLabel='>' onPageChange={handlePageClick} pageRangeDisplayed={5} pageCount={pageCount} previousLabel='<' renderOnZeroPageCount={null} forcePage={forcepage} />
              </div>
            </div>

            {/* --- Expired Tab --- */}
            <div label={formatTabLabel('หมดอายุ')}>
              <div className='product-card-list'>
                {shopitemlist.length > 0 ? (
                  shopitemlist.map((shopitem) => (
                    <div className='modern-product-card' key={shopitem.shopitem_id}>
                      <div className='product-image-container'>
                        <Image
                          src={
                            shopitem?.productitem_id && shopitem?.img1_key
                              ? `${process.env.REACT_APP_IMAGE_URL}${shopitem.productitem_id}/${shopitem.productitem_id}-1-${shopitem.img1_key}.jpg`
                              : placeholderImg
                          }
                          fallback={placeholderImg}
                        />
                      </div>
                      <div className='product-info-container'>
                        <div className='product-id-badge'>
                          #{shopitem.productitem_id}
                          <span className='badge badge-pill badge-danger ml-2'>หมดอายุ</span>
                        </div>
                        <div className='product-name-th'>{shopitem.productitem_name}</div>
                        <div className='product-name-en'>{shopitem.productitem_inter}</div>
                        <table className='card-price-table'>
                          <thead>
                            <tr>
                              <th>จำนวนชิ้น</th>
                              <th>ราคา</th>
                              <th>วันหมดอายุ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cfilter(shopitem).map((pricelist) => (
                              <tr key={pricelist.pricelist_id}>
                                <td>{pricelist.unit} ชิ้น</td>
                                <td>{pricelist.price} บาท</td>
                                <td>{renderExpireCell(pricelist.expire)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className='action-container'>
                        <button className='btn-card-action btn-card-edit' onClick={() => api_load_shopitem_stock(shopitem)}>
                          <i className='mdi mdi-file-edit-outline'></i> แก้ไข
                        </button>
                        <button
                          className='btn-card-action btn-card-delete'
                          onClick={() => {
                            setShopitemedit(shopitem);
                            setModal_popup({ modaltype: 'modal-confirm', headers: 'กรุณายืนยัน', message: 'ท่านต้องการลบรายการสินค้านี้ใช่หรือไม่?', enable: true });
                          }}
                        >
                          <i className='mdi mdi-eraser'></i> ลบ
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-center py-5 text-muted'>ไม่มีสินค้าหมดอายุ</div>
                )}
              </div>
              <div className='meya-pagination-container mt-4'>
                <ReactPaginate breakLabel='...' nextLabel='>' onPageChange={handlePageClick} pageRangeDisplayed={5} pageCount={pageCount} previousLabel='<' renderOnZeroPageCount={null} forcePage={forcepage} />
              </div>
            </div>

            <div label={formatTabLabel('สินค้านอกสิทธิทะเบียนยา')}>
              <div className='product-card-list'>
                {shopitemlist.length > 0 ? (
                  shopitemlist.map((shopitem) => (
                    <div className='modern-product-card' key={shopitem.shopitem_id}>
                      <div className='product-image-container'>
                        <Image
                          src={
                            shopitem?.productitem_id && shopitem?.img1_key
                              ? `${process.env.REACT_APP_IMAGE_URL}${shopitem.productitem_id}/${shopitem.productitem_id}-1-${shopitem.img1_key}.jpg`
                              : placeholderImg
                          }
                          fallback={placeholderImg}
                        />
                      </div>
                      <div className='product-info-container'>
                        <div className='product-id-badge'>
                          #{shopitem.productitem_id}
                          <span className='badge badge-pill badge-warning ml-2'>นอกสิทธิทะเบียนยา</span>
                        </div>
                        <div className='product-name-th'>{shopitem.productitem_name}</div>
                        <div className='product-name-en'>{shopitem.productitem_inter}</div>
                        <div className='text-muted' style={{ fontSize: '13px', marginBottom: '8px' }}>
                          สินค้านี้ถูกซ่อนจากหน้าร้าน — ติดต่อ Line @meya เพื่อขอสิทธิ์
                        </div>
                        <table className='card-price-table'>
                          <thead>
                            <tr>
                              <th>จำนวนชิ้น</th>
                              <th>ราคา</th>
                              <th>วันหมดอายุ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cfilter(shopitem).map((pricelist) => (
                              <tr key={pricelist.pricelist_id}>
                                <td>{pricelist.unit} ชิ้น</td>
                                <td>{pricelist.price} บาท</td>
                                <td>{renderExpireCell(pricelist.expire)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className='action-container'>
                        <button
                          className='btn-card-action btn-card-edit'
                          disabled
                          title='ไม่สามารถแก้ไขได้จนกว่าจะได้รับสิทธิ์ทะเบียนยา'
                          style={{ opacity: 0.5, cursor: 'not-allowed' }}
                        >
                          <i className='mdi mdi-file-edit-outline'></i> แก้ไข
                        </button>
                        <button
                          className='btn-card-action btn-card-delete'
                          onClick={() => {
                            setShopitemedit(shopitem);
                            setModal_popup({
                              modaltype: 'modal-confirm',
                              headers: 'กรุณายืนยัน',
                              message: 'ท่านต้องการลบรายการสินค้านี้ใช่หรือไม่?',
                              enable: true,
                            });
                          }}
                        >
                          <i className='mdi mdi-eraser'></i> ลบ
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-center py-5 text-muted'>ไม่มีสินค้านอกสิทธิทะเบียนยา</div>
                )}
              </div>
              <div className='meya-pagination-container mt-4'>
                <ReactPaginate breakLabel='...' nextLabel='>' onPageChange={handlePageClick} pageRangeDisplayed={5} pageCount={pageCount} previousLabel='<' renderOnZeroPageCount={null} forcePage={forcepage} />
              </div>
            </div>
          </Tabs>
        </div>
      </div>


      <div className='modal meya-overide' style={{ display: modal_editprice ? 'block' : 'none' }}>
        <div className='modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable' style={{ maxWidth: '95%', width: '900px' }}>
          <div className='modal-content' style={{ border: 'none', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', maxHeight: '92vh' }}>
            <div className='modal-header border-0 pb-0' style={{ background: colors.white, padding: '20px 24px 10px 24px', flexShrink: 0 }}>
              <h5 className='modal-title font-th py-0 mb-0 d-flex align-items-center' style={{ fontWeight: '700', fontSize: '18px', color: colors.slate800 }}>
                <div style={{ width: '36px', height: '36px', background: colors.orange50, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyCenter: 'center', marginRight: '12px' }}>
                  <i className='fa fa-pen text-warning font-size-16' style={{ margin: 'auto' }}></i>
                </div>
                แก้ไขสต็อกและตารางราคา
              </h5>
              <button type='button' className='close' onClick={() => cancel_edit()} style={{ opacity: '0.5', padding: '20px' }}>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body font-th' style={{ padding: '20px 24px', overflowY: 'auto' }}>
              <div className='row'>
                {/* Product Header Info (Left side on desktop) */}
                <div className='col-12 col-md-6 mb-4'>
                  <div className='d-flex align-items-center p-3 h-100' style={{ background: colors.slate50, borderRadius: '12px', border: `1px solid ${colors.slate200}` }}>
                    <div className='img-wrapper' style={{ width: '80px', height: '80px', flexShrink: 0 }}>
                      <img
                        src={
                          shopitemedit?.productitem_id && shopitemedit?.img1_key
                            ? `${process.env.REACT_APP_IMAGE_URL}${shopitemedit.productitem_id}/${shopitemedit.productitem_id}-1-${shopitemedit.img1_key}.jpg`
                            : placeholderImg
                        }
                        className='rounded'
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        alt='product'
                      />
                    </div>
                    <div className='ml-3 overflow-hidden'>
                      <div className='text-success font-weight-bold mb-0' style={{ fontSize: '12px' }}>#{shopitemedit.productitem_id}</div>
                      <div className='h6 mb-1 text-truncate' style={{ fontWeight: '700', color: colors.slate800, fontSize: '15px' }}>{shopitemedit.productitem_name}</div>
                      <div className='text-muted text-truncate mb-1' style={{ fontSize: '12px' }}>{shopitemedit.productitem_inter}</div>
                      <span className='status-badge-info' style={{ fontSize: '10px', padding: '2px 8px' }}>
                        <i className='fas fa-shopping-cart'></i> ขายแล้ว {shopitemedit.on_sold} ชิ้น
                      </span>
                    </div>
                  </div>
                </div>

                {/* Stock Table Section (Right side on desktop) */}
                <div className='col-12 col-md-6 mb-4'>
                  <div className='details-card h-100' style={{ padding: '16px', border: `1px solid ${colors.slate100}`, background: colors.white }}>
                    <div className='d-flex align-items-center mb-3'>
                      <i className='fas fa-boxes text-primary mr-2' style={{ fontSize: '14px' }}></i>
                      <h6 className='mb-0 font-weight-bold' style={{ fontSize: '15px' }}>ตารางจำนวนคงเหลือ (Stock)</h6>
                    </div>
                    <form id='form-stock' onSubmit={(e) => e.preventDefault()}>
                      <div style={{ overflowX: 'auto' }}>
                        <div className='price-table' style={{ minWidth: '200px' }}>
                          <div className='price-table-row text-muted' style={{ fontSize: '12px', fontWeight: '600', paddingBottom: '8px', borderBottom: `1px solid ${colors.slate100}` }}>
                            <div className='price-table-cell'>วันหมดอายุ</div>
                            <div className='price-table-cell'>คงเหลือ (ชิ้น)</div>
                          </div>
                          {tablestock.map((item) => (
                            <div className='price-table-row' key={item.expire} style={{ padding: '8px 0', borderBottom: `1px solid ${colors.slate50}` }}>
                              <div className='price-table-cell font-weight-600' style={{ color: colors.slate600, fontSize: '13px' }}>
                                {dayjs(new Date(item.expire)).format('DD MMM BBBB')}
                              </div>
                              <div className='price-table-cell'>
                                <input
                                  type='number'
                                  className='form-control form-control-sm'
                                  style={{ borderRadius: '6px', border: `1px solid ${colors.slate200}`, width: '80px' }}
                                  placeholder='จำนวน'
                                  min='0'
                                  value={item.stock}
                                  onChange={(e) => selectstock(item.expire, e.target.value)}
                                  required
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Price Table Section (Bottom full width) */}
                <div className='col-12'>
                  <div className='details-card' style={{ padding: '20px', border: `1px solid ${colors.slate100}`, background: colors.white }}>
                    <div className='d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2'>
                      <div className='d-flex align-items-center'>
                        <i className='fas fa-tags text-primary mr-2' style={{ fontSize: '14px' }}></i>
                        <h6 className='mb-0 font-weight-bold' style={{ fontSize: '15px' }}>ตารางราคา (Price List)</h6>
                      </div>
                      <button
                        className='btn btn-sm btn-outline-primary d-flex align-items-center px-3'
                        style={{ borderRadius: '8px', fontWeight: '600', fontSize: '12px' }}
                        onClick={() => addpricelist()}
                      >
                        <i className='fas fa-plus-circle mr-1'></i> เพิ่มราคา
                      </button>
                    </div>
                    <form id='form-price' onSubmit={(e) => e.preventDefault()}>
                      <div style={{ overflowX: 'auto' }}>
                        <div className='price-table' style={{ minWidth: '650px' }}>
                          <div className='price-table-row text-muted' style={{ fontSize: '12px', fontWeight: '600', paddingBottom: '10px', borderBottom: `1px solid ${colors.slate100}` }}>
                            <div className='price-table-cell' style={{ flex: '0 0 100px' }}>จำนวนชิ้น</div>
                            <div className='price-table-cell'>ราคาปกติ</div>
                            <div className='price-table-cell'>ราคาโปรโมชั่น</div>
                            <div className='price-table-cell' style={{ flex: '0 0 160px' }}>วันหมดอายุ</div>
                            <div className='price-table-cell' style={{ flex: '0 0 50px' }}></div>
                          </div>
                          {tableitem.map((item) => (
                            <div className='price-table-row' key={item.pricelist_id} style={{ padding: '10px 0', borderBottom: `1px solid ${colors.slate50}` }}>
                              <div className='price-table-cell' style={{ flex: '0 0 100px' }}>
                                <input
                                  type='number'
                                  className='form-control form-control-sm text-center'
                                  style={{ borderRadius: '6px' }}
                                  placeholder='ชิ้น'
                                  min='1'
                                  value={item.unit}
                                  onChange={(e) => selectnumber(item.pricelist_id, e.target.value, 'unit')}
                                  required
                                />
                              </div>
                              <div className='price-table-cell'>
                                <input
                                  type='number'
                                  className='form-control form-control-sm'
                                  style={{ borderRadius: '6px' }}
                                  placeholder='ปกติ'
                                  min='1'
                                  value={item.price}
                                  onChange={(e) => selectnumber(item.pricelist_id, e.target.value, 'price')}
                                  required
                                />
                              </div>
                              <div className='price-table-cell'>
                                <input
                                  type='number'
                                  className='form-control form-control-sm text-danger font-weight-bold'
                                  style={{ borderRadius: '6px' }}
                                  placeholder='โปรฯ'
                                  min='0'
                                  value={item.pricepromotion}
                                  onChange={(e) => selectnumber(item.pricelist_id, e.target.value, 'pricepromotion')}
                                />
                              </div>
                              <div className='price-table-cell' style={{ flex: '0 0 160px' }}>
                                <DatePicker
                                  allowClear={false}
                                  locale={buddhistLocale}
                                  defaultValue={dayjs(new Date(item.expire))}
                                  onChange={(date, dateString) => selectepiredate(item.pricelist_id, date, dateString)}
                                  className='w-100'
                                  size='small'
                                  style={{ borderRadius: '6px' }}
                                />
                              </div>
                              <div className='price-table-cell text-center' style={{ flex: '0 0 50px' }}>
                                <button
                                  className='btn btn-light text-danger p-1'
                                  style={{ borderRadius: '6px' }}
                                  onClick={() => removepricelist(item.pricelist_id)}
                                >
                                  <i className='fe-trash-2' style={{ fontSize: '14px' }}></i>
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer border-0 bg-light-gray' style={{ background: colors.slate50, padding: '16px 24px', flexShrink: 0 }}>
              <div className='d-flex w-100 justify-content-between align-items-center flex-wrap gap-3'>
                <button
                  className='btn btn-outline-secondary px-3'
                  style={{ borderRadius: '10px', fontWeight: '600', fontSize: '13px' }}
                  type='button'
                  onClick={() => sortitem()}
                >
                  <i className='fas fa-sort-amount-down-alt mr-1'></i> เรียงรายการ
                </button>
                <div className='d-flex gap-2'>
                  <button
                    className='btn btn-light px-4 mr-2'
                    style={{ borderRadius: '10px', fontWeight: '600', fontSize: '13px' }}
                    type='button'
                    onClick={() => cancel_edit()}
                  >
                    ยกเลิก
                  </button>
                  <button
                    className='btn btn-primary px-4'
                    style={{ borderRadius: '10px', fontWeight: '600', fontSize: '13px', background: `linear-gradient(90deg, ${colors.blueLight} 0%, ${colors.bluePrimary} 100%)`, border: 'none', boxShadow: '0 4px 12px rgba(33, 150, 243, 0.3)' }}
                    type='button'
                    onClick={() => api_edit_shopitem()}
                  >
                    บันทึกข้อมูล
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />

      {modal_editprice ? <div className='meya-overide-backdrop'></div> : null}
      <BtnGogo></BtnGogo>
      {isScannerOpen && (
        <BarcodeScanner
          onScanSuccess={(code) => {
            setIsScannerOpen(false);
            if (!code) return;
            const scanCode = code.trim();
            handleSearchChange(scanCode);

            // Auto-open edit if exact match already on current page
            const norm = (s) => String(s).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
            const searchNorm = norm(scanCode);
            const found = shopitemlist.find(
              (item) =>
                (item.productitem_barcode && norm(item.productitem_barcode) === searchNorm) ||
                (item.productitem_id && norm(item.productitem_id) === searchNorm),
            );
            if (found) {
              api_load_shopitem_stock(found);
            }
          }}
          onClose={() => setIsScannerOpen(false)}
        />
      )}
    </div>
  );
}

MyShop_Seller_MyProduct.propTypes = {
  callback_datachanged: PropTypes.func,
};

export default MyShop_Seller_MyProduct;
